import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Pagination_Material from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import WithSelect from "./../select";
import { Grid, Tooltip, Typography } from "@mzc-pdc/ui";
import { IconChevronRight } from "@mzc-cloudplex/icons";
import theme from "@styles/theme";

export const MaterialPagination = (props) => {
    const { t } = useTranslation();
    const {
        activePage: propsActivePage,
        totalItemsCount,
        itemsCountPerPage,
        onChange,
        size,
        isViewMore,
        nextToken,
        onClickViewMore,
    } = props;

    const [activePage, setActivePage] = useState(propsActivePage);
    const [pageOptions, setPageOptions] = useState([]);
    const [userInputPage, setUserInputPage] = useState(-1);
    const maximumPage =
        totalItemsCount < itemsCountPerPage
            ? 1
            : Math.floor(totalItemsCount / itemsCountPerPage) + (totalItemsCount % itemsCountPerPage === 0 ? 0 : 1);

    // console.log('totalItemsCount', totalItemsCount)
    // console.log('itemsCountPerPage', itemsCountPerPage)
    // console.log('maximumPage', maximumPage)

    useEffect(() => {
        if (propsActivePage !== activePage) {
            onChange(activePage);
        }
    }, [activePage]);

    useEffect(() => {
        setActivePage(propsActivePage);
    }, [propsActivePage]);

    useEffect(() => {
        initPageOptions();
    }, [maximumPage]);

    /**
     * 처음·이전·다음·마지막 이동 버튼은 아이콘만 있어 의미가 드러나지 않으므로 안내 툴팁을 노출한다. (DAM-306)
     * 숫자 페이지와 클릭이 막힌 생략(...) 항목은 툴팁 대상이 아니다.
     */
    const renderPaginationItem = (item) => {
        const navigationLabels = {
            first: t(`common::label::Go to first page`, `Go to first page`),
            previous: t(`common::label::Go to previous page`, `Go to previous page`),
            next: t(`common::label::Go to next page`, `Go to next page`),
            last: t(`common::label::Go to last page`, `Go to last page`),
        };
        const label = navigationLabels[item.type];
        if (!label) return <PaginationItem {...item} />;

        return (
            <Tooltip title={label}>
                <PaginationItem {...item} />
            </Tooltip>
        );
    };

    const initPageOptions = () => {
        let makePagesArray = [];
        for (let i = 1; i <= maximumPage; i++) {
            makePagesArray.push({
                label: i,
                value: i,
            });
        }
        setPageOptions(makePagesArray);
    };

    const changePage = (page) => {
        setActivePage(page);
    };

    // let checkPaginationItem = {
    //     'first': 0,
    //     'previous': 0,
    //     'start-ellipsis' : 0,
    //     'page' : 0,
    //     'end-ellipsis': 0,
    //     'next' : 0,
    //     'last' : 0,
    // }
    // console.log('checkPaginationItem',checkPaginationItem)

    return (
        <Grid item sx={{ display: "flex" }} alignItems={"center"}>
            <Pagination_Material
                page={activePage}
                count={maximumPage}
                showFirstButton={true}
                showLastButton={isViewMore ? false : true}
                className={size ? "pagination-sm" : ""}
                siblingCount={1}
                boundaryCount={1}
                getItemAriaLabel={(type, page) => {
                    switch (type) {
                        case "first":
                            return t(`common::label::Go to first page`, `Go to first page`);
                        case "previous":
                            return t(`common::label::Go to previous page`, `Go to previous page`);
                        case "next":
                            return t(`common::label::Go to next page`, `Go to next page`);
                        case "last":
                            return t(`common::label::Go to last page`, `Go to last page`);
                        default:
                            return t(`common::label::Go to page {{page}}`, {
                                page,
                                defaultValue: `Go to page ${page}`,
                            });
                    }
                }}
                onChange={(event, page) => {
                    changePage(page);
                }}
                sx={{
                    "&&": {
                        ".MuiPaginationItem-root": {
                            height: `auto`,
                            "&.Mui-selected": {
                                color: theme.palette.secondary.main,
                                backgroundColor: `transparent`,
                            },
                        },
                    },
                }}
                renderItem={(item) => {
                    // checkPaginationItem[item.type] += 1;
                    // console.log('item', item)
                    if (
                        maximumPage > 7 &&
                        item.type === "page" &&
                        item.page !== activePage &&
                        item.page < 6 &&
                        activePage < 6
                    ) {
                        // 이 부분은 페이지네이션 5개 나오는부분을 4개로 강제로 줄여주기 위해 끝에꺼 한개를 숨김으로써
                        // 생기는 페이지네이션아이템 누락되는 첫번째에서 4번째요소의 불안정을 자연스럽게 해소하기 위해 추가한 로직임
                        if (item.page === 5 && activePage < 5 && activePage !== 4) {
                            return <React.Fragment></React.Fragment>;
                        }
                        if (item.page < 6 && activePage > 3) {
                            if (item.page === 2) {
                                item["aria-label"] = t(
                                    `common::label::Go to start-ellipsis page`,
                                    `Go to start-ellipsis page`,
                                );
                                item["type"] = "start-ellipsis";
                                item["page"] = null;
                                item.onClick = (e) => {
                                    e.stopPropagation();
                                };
                                return renderPaginationItem(item);
                            } else {
                                return renderPaginationItem(item);
                            }
                        }
                    }
                    if (
                        maximumPage > 7 &&
                        item.type === "page" &&
                        item.page !== activePage &&
                        item.page > maximumPage - 5 &&
                        item.page !== maximumPage &&
                        activePage > maximumPage - 4
                    ) {
                        // 이 부분은 페이지네이션 5개 나오는부분을 4개로 강제로 줄여주기 위해 끝에꺼 한개를 숨김으로써
                        // 생기는 페이지네이션아이템 누락되는 끝에서 4번째요소의 불안정을 자연스럽게 해소하기 위해 추가한 로직임
                        if (item.page === maximumPage - 2) {
                            return renderPaginationItem(item);
                        }
                        if (item.page === maximumPage - 1 && activePage < maximumPage - 2) {
                            item["aria-label"] = t(`common::label::Go to end-ellipsis page`, `Go to end-ellipsis page`);
                            item["type"] = "end-ellipsis";
                            item["page"] = null;
                            item.onClick = (e) => {
                                e.stopPropagation();
                            };
                            return renderPaginationItem(item);
                        } else {
                            if (item.page === maximumPage - 4 && activePage < maximumPage - 2) {
                                return renderPaginationItem(item);
                            } else if (item.page === maximumPage - 4 && activePage >= maximumPage - 2) {
                                return <React.Fragment></React.Fragment>;
                            }
                            return renderPaginationItem(item);
                        }
                    }
                    if (
                        maximumPage > 7 &&
                        item.type === "page" &&
                        item.page !== activePage &&
                        item.page === maximumPage - 4 &&
                        activePage > maximumPage - 4
                    ) {
                        return <React.Fragment></React.Fragment>;
                    }
                    return renderPaginationItem(item);
                }}
            />
            {isViewMore && (
                <button
                    className="btn btn-ghost btn-viewmore"
                    disabled={!nextToken}
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        onClickViewMore();
                    }}
                >
                    <Typography color={!nextToken ? "text.disabled" : "text.primary"}>
                        {t(`common::label::View More`)}
                    </Typography>
                    <Grid
                        container
                        alignItems={"center"}
                        justifyContent={"center"}
                        ml={1}
                        sx={{
                            display: `inline-flex`,
                            width: 20,
                            height: 20,
                            borderRadius: 1,
                            backgroundColor: !nextToken ? theme.palette.grey[500] : theme.palette.secondary.main,
                        }}
                    >
                        <IconChevronRight
                            size={8}
                            htmlColor={!nextToken ? theme.palette.common.white : theme.palette.secondary.main}
                        />
                    </Grid>
                </button>
            )}
            <div className="pagination-input">
                <WithSelect
                    defaultValue={activePage}
                    options={pageOptions}
                    size={size ? size : ""}
                    onChange={(option) => {
                        changePage(option.value);
                    }}
                    onInputChange={(input) => {
                        if (input) {
                            console.log(input);
                            const inputValue = Number(input);
                            if (!Number.isNaN(inputValue) && Number.isInteger(inputValue)) {
                                console.log(inputValue);
                                setUserInputPage(inputValue);
                            }
                        }
                    }}
                    noOptionsMessage={`No pages.`}
                />
                <button
                    type="button"
                    className="btn btn-transparent"
                    onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        if (userInputPage !== -1 && userInputPage <= maximumPage) {
                            changePage(userInputPage);
                            setUserInputPage(-1);
                        } else {
                            changePage(activePage);
                        }
                    }}
                >
                    <i className="sprite sprite-angle-down"></i>
                </button>
            </div>
        </Grid>
    );
};

export default MaterialPagination;
